import { createClient } from '@supabase/supabase-js';

// Auth client (bgbjlhjysbxticsixqte) - for login, signup, session management
const supabaseAuthUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAuthAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabaseAuth = createClient(supabaseAuthUrl, supabaseAuthAnonKey);

// Data client (hyaxsodkrebdrwyquaxf) - for tables, queries, CRUD
const supabaseDbUrl = process.env.REACT_APP_SUPABASE_DB_URL;
const supabaseDbAnonKey = process.env.REACT_APP_SUPABASE_DB_ANON_KEY;
export const supabaseDb = createClient(supabaseDbUrl, supabaseDbAnonKey);

// Default export for backward compatibility (auth client)
export const supabase = supabaseAuth;

// Helper function to get current user (from auth project)
export const getCurrentUser = async () => {
  const { data: { user } } = await supabaseAuth.auth.getUser();
  return user;
};

// Helper function to get user profile (from data project)
export const getUserProfile = async (userId) => {
  const { data, error } = await supabaseDb
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  
  if (error) throw error;
  return data;
};

// Helper function to check user role (from data project)
export const checkUserRole = async (userId, requiredRole) => {
  const profile = await getUserProfile(userId);
  
  const roleHierarchy = {
    'admin': 4,
    'owner': 3,
    'member': 2,
    'customer': 1
  };
  
  // Check platform_role first (AGI admin)
  if (profile.platform_role === 'admin') return true;
  
  // Check company role from localStorage (set by /auth/me)
  const storedData = JSON.parse(localStorage.getItem('authContext') || '{}');
  const companyRole = storedData.company_role || profile.role;
  
  return (roleHierarchy[companyRole] || 0) >= (roleHierarchy[requiredRole] || 0);
};

// Get the user's effective role (considering company memberships)
export const getEffectiveRole = () => {
  const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
  if (authContext.isPlatformAdmin) return 'admin';
  return authContext.company_role || authContext.role || 'customer';
};

// Check if user is a platform admin (AGI staff)
export const isPlatformAdmin = () => {
  const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
  return authContext.isPlatformAdmin === true;
};

// Check if user is company staff (owner or member)
export const isCompanyStaff = () => {
  const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
  return ['owner', 'member'].includes(authContext.company_role);
};

// Check if user is company owner
export const isCompanyOwner = () => {
  const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
  return authContext.company_role === 'owner';
};

// Get current company info
export const getCurrentCompany = () => {
  const authContext = JSON.parse(localStorage.getItem('authContext') || '{}');
  return authContext.company || null;
};

// Helper function to sign out (from auth project)
export const signOut = async () => {
  const { error } = await supabaseAuth.auth.signOut();
  if (error) throw error;
  localStorage.removeItem('user');
  localStorage.removeItem('profile');
  localStorage.removeItem('authContext');
};
